<template>
	<div class="platform-picker" :style="rootCss">
		<div class="picker-container" v-if="hasPlatforms">
			<div class="column-header channel-name">Channel Name</div>
			<div class="column-header channel-status">Status</div>
			<div class="column-header channel-edit">&nbsp;</div>
			<template v-for="platform of platforms">
				<div class="column-cell channel-name" :key="platform.id">{{ platform.name }}</div>
				<div class="column-cell channel-status" :key="platform.id">{{ getStatusText(platform) }}</div>
				<div class="column-cell channel-edit" :key="platform.id">Edit</div>
			</template>
		</div>
		<div class="btn add-button">Add Distribution Channel</div>
	</div>
</template>

<script>
export default {
	props: {
		color: {
			type: String,
			default: '',
		},
		hasPlatforms() {
			return this.platforms && this.platforms.length > 0;
		},
	},
	computed: {
		rootCss() {
			return {
				'--primary-color': this.color || 'inherit',
			};
		},
	},
	data() {
		return {
			platforms: [],
		};
	},
};
</script>

<style scoped lang="scss">
.platform-picker {
	margin: 50px auto;

	.picker-container {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		grid-auto-rows: 1fr;
		margin-bottom: 30px;
	}

	.add-button {
		text-transform: uppercase;
		background-color: var(--primary-color);
		color: #fff;
		font-weight: bold;
		font-size: 10px;
		padding: 10px 20px;
	}
}
</style>
